export interface OpenAIModePricing {
    inputCostPerToken: number; // USD per token
    outputCostPerToken: number; // USD per token
}

// Prices from https://platform.openai.com/docs/pricing in $/token
export const OPENAI_PRICING: Record<string, OpenAIModePricing> = {
    "gpt-5-4": { inputCostPerToken: 2.5 / 1_000_000, outputCostPerToken: 15 / 1_000_000 },
    "gpt-5-2": { inputCostPerToken: 1.75 / 1_000_000, outputCostPerToken: 14 / 1_000_000 },
    "gpt-5-1": { inputCostPerToken: 1.25 / 1_000_000, outputCostPerToken: 10 / 1_000_000 },
    "gpt-5": { inputCostPerToken: 1.25 / 1_000_000, outputCostPerToken: 10 / 1_000_000 },
    "gpt-5-mini": { inputCostPerToken: 0.25 / 1_000_000, outputCostPerToken: 2 / 1_000_000 },
    "gpt-5-nano": { inputCostPerToken: 0.05 / 1_000_000, outputCostPerToken: 0.4 / 1_000_000 },
    "gpt-5-4-mini": { inputCostPerToken: 0.75 / 1_000_000, outputCostPerToken: 4.5 / 1_000_000 },
    "gpt-5-4-nano": { inputCostPerToken: 0.2 / 1_000_000, outputCostPerToken: 1.25 / 1_000_000 },
    "gpt-4-1": { inputCostPerToken: 2 / 1_000_000, outputCostPerToken: 8 / 1_000_000 },
    "gpt-4-1-mini": { inputCostPerToken: 0.4 / 1_000_000, outputCostPerToken: 1.6 / 1_000_000 },
    "gpt-4-1-nano": { inputCostPerToken: 0.1 / 1_000_000, outputCostPerToken: 0.4 / 1_000_000 },
    "gpt-4o": { inputCostPerToken: 2.5 / 1_000_000, outputCostPerToken: 10 / 1_000_000 },
    "gpt-4o-mini": { inputCostPerToken: 0.15 / 1_000_000, outputCostPerToken: 0.6 / 1_000_000 },
    "o3": { inputCostPerToken: 2 / 1_000_000, outputCostPerToken: 8 / 1_000_000 },
    "o4-mini": { inputCostPerToken: 1.1 / 1_000_000, outputCostPerToken: 4.4 / 1_000_000 }
};

export function priceToCreditConversion(costPerTokenUSD: number): number {
    const CREDIT_PRICE_USD = 3;
    const MARGIN = 1.5;
    return (costPerTokenUSD * MARGIN) / CREDIT_PRICE_USD;
}

export function getConversionRateForModel(model: string, type: "input" | "output"): number | null {
    const pricing = OPENAI_PRICING[model];
    if (!pricing) return null;
    const cost = type === "input" ? pricing.inputCostPerToken : pricing.outputCostPerToken;
    return priceToCreditConversion(cost);
}
